import React from 'react'
import {Icon} from '@chakra-ui/react'

const UpIcon = (props) => {
    return (
        <Icon viewBox="0 0 40 40" {...props}>
            <path
                d="M34.1004 17.05L32.0004 19.1L23.8004 10.9L21.5004 8.35005V37.05H18.5004V8.35005L16.1504 10.9L8.00039 19.1L5.90039 17.05L20.0004 2.95005L34.1004 17.05Z"
                fill="currentColor"
            />
        </Icon>
    )
}

export default UpIcon
